import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

// Public pages
import HomePage from "./pages/HomePage";
import LearnPage from "./pages/LearnPage";
import BusinessPage from "./pages/BusinessPage";
import TalentPage from "./pages/TalentPage";
import DetailPage from "./pages/DetailPage";
import CourseDetailPage from "./pages/CourseDetailPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ResourcesPublicPage from "./pages/ResourcesPage";
import Contact from "./pages/Contact";

// Admin pages
import LoginPage from "./admin/pages/LoginPage";
import DashboardPage from "./admin/pages/DashboardPage";
import CoursesPage from "./admin/pages/CoursesPage";
import LeadsPage from "./admin/pages/LeadsPage";
import LeadDetailPage from "./admin/pages/LeadDetailPage";
import UsersPage from "./admin/pages/UsersPage";
import ResourcesPage from "./admin/pages/ResourcesPage";
import EventsPage from "./admin/pages/EventsPage";
import SettingsPage from "./admin/pages/SettingsPage";
import AuditLogsPage from "./admin/pages/AuditLogsPage";
import LearningPathsPage from "./admin/pages/LearningPathsPage";
import ServicesAdminPage from "./admin/pages/ServicesAdminPage";
import MetricsPage from "./admin/pages/MetricsPage";
import PagesAdminPage from "./admin/pages/PagesAdminPage";
import TechStackPage from "./admin/pages/TechStackPage";
import ProtectedRoute from "./admin/components/ProtectedRoute";
import ResourceDetailPage from "./pages/ResourceDetailPage";
import ResourceCategoriesPage from "./admin/pages/Resourcecategoriespage";
import SiteConfigurationPage from "./admin/pages/Siteconfigurationpage";
import ServiceCategoriesAdminPage from "./admin/pages/ServiceCategoriesAdminPage";
import BusinessOfferingsPage from "./admin/pages/BusinessOfferingsPage";
import ProductCategoriesPage from "./admin/pages/ProductCategoriesPage";
import VendorsPage from "./admin/pages/VendorsPage";
import ProductsPage from "./admin/pages/ProductsPage";
import PartnersPage from "./admin/pages/PartnersPage";
import BusinessInquiriesPage from "./admin/pages/BusinessInquiriesPage";
import PageContentPage from "./admin/pages/PageContentPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import OfferingDetailPage from "./pages/OfferingDetailPage";
import PartnerDetailPage from "./pages/PartnerDetailPage";
import OverviewDetailPage from "./pages/OverviewDetailPage";
import LearningPathDetailPage from "./pages/Learningpathdetailpage";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/Privacypolicy";
import TrainingsPage from "./admin/pages/TrainingsPage";
import TestimonialsPage from "./admin/pages/TestimonialsPage";
import MenuAdminPage from "./admin/pages/MenuAdminPage";
import TrainingDetailPage from "./pages/TrainingDetailPage";
import EnrollPage from "./pages/EnrollPage";
import PublicTrainingsPage from "./pages/PublicTrainingsPage";
import ProfessionalTrainingsPage from "./pages/ProfessionalTrainingsPage";
import TechnologyTrainingsPage from "./pages/TechnologyTrainingsPage";
import CourseCategoriesAdminPage from "./admin/pages/Coursecategoriesadminpage";

// Scrolls the window to the top whenever the route path changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public */}
        <Route path="/" element={<HomePage />} />
        <Route path="/public/trainings" element={<PublicTrainingsPage/>} />
        <Route path="/public/technologies-training" element={<TechnologyTrainingsPage/>} />
<Route path="/public/professional-training" element={<ProfessionalTrainingsPage />} />
<Route path="public/trainings/slug/:slug" element={<TrainingDetailPage />} />
<Route path="/enroll" element={<EnrollPage />} />
        <Route path="/learn" element={<LearnPage />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/talent" element={<TalentPage />} />
        <Route path="/resources" element={<ResourcesPublicPage />} />
        <Route path="/courses/:slug" element={<CourseDetailPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/resources/:slug" element={<ResourceDetailPage />} />
        <Route path="/detail/:page" element={<DetailPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/products/:slug" element={<ProductDetailPage />} />
        <Route path="/business/services/:slug" element={<OfferingDetailPage />} />
        <Route path="/partners/:id" element={<PartnerDetailPage />} />
        <Route path="/business/overview/:slug" element={<OverviewDetailPage />} />
        <Route path="/learning-paths/:slug" element={<LearningPathDetailPage />} />

        {/* Admin auth (public) */}
        <Route path="/admin/login" element={<LoginPage />} />

        {/* Admin protected */}
        <Route path="/admin" element={<ProtectedRoute />}>
        <Route path="/admin/courses-category" element={<CourseCategoriesAdminPage />}/>
        <Route path="trainings" element={<TrainingsPage />} />
        <Route path="/admin/navbar-settings" element={<MenuAdminPage />} />
          <Route path="testimonials" element={<TestimonialsPage />} />
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="courses" element={<CoursesPage />} />
          <Route path="learning-paths" element={<LearningPathsPage />} />
          <Route path="services" element={<ServicesAdminPage />} />
          <Route path="services-category" element={<ServiceCategoriesAdminPage />} />
          <Route path="leads" element={<LeadsPage />} />
          <Route path="leads/:id" element={<LeadDetailPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="resources" element={<ResourcesPage />} />
          <Route path="resources-category" element={<ResourceCategoriesPage />} />
          <Route path="pages" element={<PagesAdminPage />} />
          <Route path="metrics" element={<MetricsPage />} />
          <Route path="tech-stack" element={<TechStackPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="site-config" element={<SiteConfigurationPage />} />
          <Route path="audit-logs" element={<AuditLogsPage />} />

          <Route path="/admin/business-offerings" element={<BusinessOfferingsPage />} />
          <Route path="/admin/product-categories" element={<ProductCategoriesPage />} />
          <Route path="/admin/vendors" element={<VendorsPage />} />
          <Route path="/admin/products" element={<ProductsPage />} />
          <Route path="/admin/partners" element={<PartnersPage />} />
          <Route path="/admin/business-inquiries" element={<BusinessInquiriesPage />} />
          <Route path="/admin/business-page-content" element={<PageContentPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}